var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCabinet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42188 1.52349C2.72812 1.16802 1.85625 1.15631 1.14844 1.48834C0.440625 1.82037 0 2.44537 0 3.12506V16.8751C0 17.5547 0.440625 18.1797 1.14844 18.5118C1.85625 18.8438 2.72812 18.8282 3.42188 18.4766L16.9219 11.6016C17.5922 11.2618 18 10.6563 18 10.0001C18 9.34381 17.5922 8.74224 16.9219 8.39849L3.42188 1.52349Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinet);
export default __webpack_public_path__ + "static/media/cabinet.d855b59630294322bbc4698130c19f34.svg";
export { ForwardRef as ReactComponent };